import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { FormsModule } from '@angular/forms';
import { MaterialModule } from '../material/material.module';
import { EditGroupOrTeamDialogComponent } from './edit-group-or-team-dialog.component';
import { NgxCurrencyWrapperModule } from '../../shared/ngx-currency-wrapper.module';

@NgModule({
    imports: [
        CommonModule,
        MaterialModule,
        FlexLayoutModule.withConfig({ useColumnBasisZero: false }),
        FormsModule,
        NgxCurrencyWrapperModule
    ],
    exports: [EditGroupOrTeamDialogComponent],
    declarations: [EditGroupOrTeamDialogComponent]
})
export class EditGroupOrTeamDialogModule { }
